import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'CHILD_PROFILE/GROUP_MOVE';

export const {action: init} = createAction(`${domain}/INIT`, () => ({}));

export const {
    action: submit,
    success: submitSuccess,
    failed: submitFailed,
} = createAction(`${domain}/SUBMIT`, () => ({}));
